export default __webpack_public_path__ + "static/media/40.7c85b512.svg";